import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "../pages/HomePage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/faq",
    name: "Faq",
    component: () =>
      import(/* webpackChunkName: "help" */ "../pages/help/FaqPage.vue"),
  },
  {
    path: "/compatibility",
    name: "Compatibility",
    component: () =>
      import(
        /* webpackChunkName: "compatibility" */ "../pages/CompatibilityPage.vue"
      ),
  },
  {
    path: "/help",
    name: "Help",
    component: () =>
      import(/* webpackChunkName: "help" */ "../pages/HelpPage.vue"),
  },
  {
    path: "/help/connectCanon",
    name: "HelpConnectCanon",
    component: () =>
      import(
        /* webpackChunkName: "help" */ "../pages/help/ConnectCanonPage.vue"
      ),
  },
  {
    path: "/help/connectSony",
    name: "HelpConnectSony",
    component: () =>
      import(
        /* webpackChunkName: "help" */ "../pages/help/ConnectSonyPage.vue"
      ),
  },
  {
    path: "/help/connectSonyPlaymemories",
    name: "HelpConnectSonyPlaymemories",
    component: () =>
      import(
        /* webpackChunkName: "help" */ "../pages/help/ConnectSonyPlaymemoriesPage.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
